import { render } from "./Viewer3D.vue?vue&type=template&id=0f07676f&scoped=true"
import script from "./Viewer3D.vue?vue&type=script&lang=js"
export * from "./Viewer3D.vue?vue&type=script&lang=js"

import "./Viewer3D.vue?vue&type=style&index=0&id=0f07676f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0f07676f"

export default script